import React from 'react';
import { Box, COLORS, styled, SxProps, Theme } from '@dripcapital/dripui-v1';

type Props = {
  children: React.ReactNode;
  dataTestId?: string;
  _sx?: SxProps<Theme>;
};

const BoxContainer = styled(Box)(({ theme }) => {
  return {
    flexGrow: theme.spacing(1),
    padding: `${theme.spacing(2)} ${theme.spacing(8)}`,
    minHeight: '98vh',
    height: '100%',
    backgroundColor: COLORS.WHITE,
    '@media (max-width: 1024px)': {
      padding: `${theme.spacing(1.6)} ${theme.spacing(2)}`,
    },
  };
});

const MainContainer: React.FC<Props> = ({
  children,
  dataTestId,
  _sx,
}: Props) => (
  <BoxContainer dataTestId={dataTestId} _sx={_sx}>
    {children}
  </BoxContainer>
);

export default MainContainer;
